import { Box, Modal, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from 'src/styles/theme';

const modalStyle = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  maxHeight: '90%',
  overflow: 'auto',
  mb: '1rem',
  width: {
    lg: '40%',
    md: '65%',
    sm: '80%',
    xs: '95%',
  },
};

/**
 * InfoModal is a component that renders a modal with a passed content and open and close functionality
 *
 * @param {Object} props - The props for the component.
 * @param {string} props.content - The content that will be rendered inside the modal
 * @param {boolean} props.open - The flag that determines if the modal should be open or closed
 * @param {function} props.onClose - The function that will be called when the modal's close button is clicked
 *
 * @returns {ReactElement} - A React element that renders the modal and its content
 */
const InfoModal = ({ content, open = false, onClose }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
            <CloseIcon
              sx={{
                color: 'grey',
                cursor: 'pointer',
                float: 'right',
              }}
              onClick={onClose}
            />
          </Box>
          <Box>{content}</Box>

          <Box sx={{ display: 'flex', justifyContent: 'end', mt: '1rem' }}>
            <Button data-cy="close" type="submit" variant="contained" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default InfoModal;
